var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',[_c('UnconfirmedMessage')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }